import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { PrimaryButton, SecondaryButton } from '../../components';

import css from './DraftListingBanner.module.css';

const DraftListingBanner = props => {
    const { rootClassName, className, draftListingId, isAuthenticated, onDiscardDraft, onContinueEditing } = props;
    const classes = classNames(rootClassName || css.root, className);

    if (!draftListingId) {
        return null;
    }

    return (
        <div className={classes}>
            <p className={css.text}>
                <FormattedMessage id="DraftListingBanner.message" />
            </p>
            <div className={css.buttons}>
                <PrimaryButton onClick={onContinueEditing}>
                    <FormattedMessage id="DraftListingBanner.continueEditing" />
                </PrimaryButton>
                <SecondaryButton onClick={onDiscardDraft}>
                    <FormattedMessage id="DraftListingBanner.discardDraft" />
                </SecondaryButton>
            </div>
        </div>
    );
};

DraftListingBanner.defaultProps = {
    rootClassName: null,
    className: null,
    draftListingId: null,
};

DraftListingBanner.propTypes = {
    rootClassName: PropTypes.string,
    className: PropTypes.string,
    draftListingId: PropTypes.string,
};

export default DraftListingBanner; 